import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;

    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start < maxVisible - 1) start = Math.max(1, end - maxVisible + 1);

    for (let i = start; i <= end; i++) pages.push(i);

    return (
        <div className="flex items-center justify-center gap-1 pt-4" data-testid="pagination">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="btn-icon disabled:opacity-30"
                data-testid="pagination-prev"
            >
                <ChevronLeft size={16} />
            </button>
            {start > 1 && (
                <>
                    <button onClick={() => onPageChange(1)} className="pagination-btn">1</button>
                    {start > 2 && <span className="text-gray-300 px-1">...</span>}
                </>
            )}
            {pages.map(p => (
                <button
                    key={p}
                    onClick={() => onPageChange(p)}
                    className={`pagination-btn ${p === currentPage ? 'pagination-btn-active' : ''}`}
                    data-testid={`pagination-page-${p}`}
                >
                    {p}
                </button>
            ))}
            {end < totalPages && (
                <>
                    {end < totalPages - 1 && <span className="text-gray-300 px-1">...</span>}
                    <button onClick={() => onPageChange(totalPages)} className="pagination-btn">{totalPages}</button>
                </>
            )}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="btn-icon disabled:opacity-30"
                data-testid="pagination-next"
            >
                <ChevronRight size={16} />
            </button>
        </div>
    );
}
